import ArrowRight from '../../src/legacy/ArrowRight.tsx';
export default ArrowRight;
